export const businessEn = {
  'business.common.accessibility': 'Accessibility',
  'business.common.active': 'Active',
  'business.common.business': 'Business',
  'business.common.continue': 'Continue',
  'business.common.delete': 'Delete',
  'business.common.description': 'Description',
  'business.common.directions': 'Directions',
  'business.common.edit': 'Edit',
  'business.common.eventCount': 'no events | event | events',
  'business.common.introduction': 'Introduction',
  'business.common.name': 'Name',
  'business.common.next': 'Next',
  'business.common.pageOf': 'Page {page} of {total}',
  'business.common.paused': 'Paused',
  'business.common.previous': 'Previous',
  'business.common.remove': 'Remove',
  'business.common.type': 'Type',
  'business.common.verified': 'Verified',
  'business.category.label': 'Business category',
  'business.category.select': 'Select a category',
  'business.category.help': 'Choose the category that best describes this business.',
  'business.discovery.storefrontAlt': '{name} storefront',
  'business.discovery.fallbackDescription': 'Discover this local business.',
  'business.discovery.booking': 'Booking',
  'business.discovery.accessibilityAvailable': 'Accessibility information available',
  'business.discovery.loading': 'Loading business',
  'business.discovery.localityUnavailable': 'Locality not specified',
  'business.discovery.openNow': 'Open now',
  'business.discovery.closed': 'Closed',
  'business.follow.savedToast': '{name} saved. Event alerts are on.',
  'business.follow.followError': 'Could not follow this business.',
  'business.follow.removedToast': '{name} removed from your saved businesses.',
  'business.follow.unfollowError': 'Could not unfollow this business.',
  'business.follow.preferenceError': 'Could not update this alert.',
  'business.follow.save': 'Save & follow',
  'business.follow.saved': 'Saved',
  'business.follow.preferencesAria': 'Business alert preferences',
  'business.follow.alertsFrom': 'Alerts from {name}',
  'business.follow.alertPrivacy': 'In-app alerts are always private. Email and web push follow your global settings.',
  'business.follow.newEvents': 'New events',
  'business.follow.newSessions': 'New sessions',
  'business.follow.availability': 'Places become available',
  'business.attachments.previewAlt': 'Attachment preview: {filename}',
  'business.attachments.attachmentNumber': 'Attachment {number}',
  'business.attachments.downloadFailed': 'Attachment download failed.',
  'business.attachments.downloadError': 'Attachment could not be downloaded.',
  'business.photos.viewerAria': '{name} photo viewer',
  'business.photos.position': 'Photo {current} of {total}',
  'business.photos.close': 'Close photo viewer',
  'business.photos.previous': 'Previous photo',
  'business.photos.next': 'Next photo',
  'business.checklist.identity': 'Identity',
  'business.checklist.identityDescription': 'Name, username, category, and verification',
  'business.checklist.imagery': 'Imagery',
  'business.checklist.imageryDescription': 'Logo and at least one business photo',
  'business.checklist.description': 'Description',
  'business.checklist.descriptionDescription': 'A useful public introduction',
  'business.checklist.openingHours': 'Opening hours',
  'business.checklist.openingHoursDescription': 'Regular or exceptional opening times',
  'business.checklist.location': 'Location',
  'business.checklist.locationDescription': 'Public address and map position',
  'business.checklist.accessibilityDescription': 'Practical accessibility information',
  'business.checklist.communityPosts': 'Community posts',
  'business.checklist.communityPostsDescription': 'At least one published update',
  'business.checklist.events': 'Events',
  'business.checklist.eventsDescription': 'At least one event in your programme',
  'business.checklist.title': 'Profile completeness',
  'business.checklist.help': 'Help visitors understand your business and choose what to do next.',
  'business.checklist.completeCount': '{completed} of {total} complete',
  'business.checklist.progressAria': 'Business profile {progress}% complete',
  'business.report.title': 'Report {type}',
  'business.report.typePost': 'post',
  'business.report.typeComment': 'comment',
  'business.report.body': 'Briefly explain why this content should be reviewed.',
  'business.report.reason': 'Reason for reporting',
  'business.report.submit': 'Submit report',
  'business.report.success': 'Thanks. This content has been reported.',
  'business.report.error': 'The report could not be submitted.',
  'business.report.action': 'Report',
  'business.booking.beforeYouBook': 'Before you book',
  'business.booking.verifiedBusiness': 'This is a verified Vennevent business.',
  'business.booking.verificationUnavailable': 'Business verification is not available.',
  'business.booking.askAccessibility': 'Ask the business about accessibility arrangements before booking.',
  'business.booking.paymentSafety': 'Any price and payment requirement is shown before confirmation. Vennevent does not store your payment credentials.',
  'business.booking.cancellationVaries': 'Cancellation terms can vary by resource and are shown below when supplied.',
  'business.booking.messageBusiness': 'Message this business',
  'business.booking.supportDetails': 'View business support details',
  'business.booking.website': 'Business website',
  'business.booking.cancellation': 'Cancellation:',
  'business.subscription.awaitingApproval': 'The existing Vipps agreement is still awaiting approval.',
  'business.subscription.checkoutError': 'Could not start subscription checkout.',
  'business.subscription.redirectError': 'The secure subscription payment page could not be opened. No plan change was confirmed.',
  'business.subscription.cancelTitle': 'Cancel Pro subscription?',
  'business.subscription.cancelBody':
    'Pro remains available through the paid or trial period. Existing bookings, invoices and customer obligations stay accessible.',
  'business.subscription.scheduleCancellation': 'Schedule cancellation',
  'business.subscription.keepPro': 'Keep Pro',
  'business.subscription.cancellationScheduled': 'Cancellation scheduled.',
  'business.subscription.cancelError': 'Could not cancel the subscription.',
  'business.subscription.title': 'Plan and billing',
  'business.subscription.paymentInfo': 'Vipps MobilePay manages the payment agreement. Prices include 25% Norwegian VAT.',
  'business.subscription.loading': 'Loading billing information',
  'business.subscription.unavailable': 'Billing information is temporarily unavailable. No plan change has been made.',
  'business.subscription.trialEnds': 'Trial ends {date}.',
  'business.subscription.paymentAttention': 'Payment needs attention in Vipps. Pro remains available until {date}.',
  'business.subscription.actionsPaused': 'Pro actions are paused. Existing bookings and invoices remain available.',
  'business.subscription.proEnds': 'Pro ends {date}. Existing customer records will not be hidden.',
  'business.subscription.periodEnds': 'Current period ends {date}.',
  'business.subscription.cancelPlan': 'Cancel plan',
  'business.subscription.annual': 'annual',
  'business.subscription.monthly': 'monthly',
  'business.subscription.trialDescription': '{days}-day free trial, then renews automatically. Cancel any time.',
  'business.subscription.featurePayments': 'Vipps payments and resource booking',
  'business.subscription.featureAnalytics': 'Parent events and enhanced aggregate analytics',
  'business.subscription.featureLimits': 'Higher operational limits',
  'business.subscription.startTrial': 'Start free trial',
  'business.subscription.invoices': 'Invoices',
  'business.subscription.invoice': 'Invoice',
  'business.subscription.date': 'Date',
  'business.subscription.total': 'Total',
  'business.subscription.vatIncluded': 'VAT included',
  'business.subscription.status': 'Status',
  'business.subscription.statusTrialing': 'Trial',
  'business.subscription.statusActive': 'Active',
  'business.subscription.statusGrace': 'Payment grace period',
  'business.subscription.statusPastDue': 'Past due',
  'business.subscription.statusCancelScheduled': 'Cancellation scheduled',
  'business.subscription.statusCanceled': 'Cancelled',
  'business.subscription.statusExpired': 'Expired',
  'business.resources.embedTitle': 'Book with us',
  'business.resources.created': 'Resource created.',
  'business.resources.createError': 'Could not create the resource.',
  'business.resources.settingsSaved': 'Booking page settings saved.',
  'business.resources.settingsError': 'Could not save the booking page.',
  'business.resources.title': 'Bookable resources',
  'business.resources.intro': 'Manage rooms, courts, tables, equipment, or instructor time.',
  'business.resources.customerView': 'Customer view',
  'business.resources.capacityValue': 'capacity {capacity}',
  'business.resources.empty': 'No resources yet.',
  'business.resources.add': 'Add resource',
  'business.resources.minimumDuration': 'Minimum duration (minutes)',
  'business.resources.maximumDuration': 'Maximum duration (minutes)',
  'business.resources.bookingStep': 'Booking step (minutes)',
  'business.resources.pricePerStep': 'Price per step (øre)',
  'business.resources.cancellationTerms': 'Cancellation terms',
  'business.resources.exclusive': 'Exclusive (one booking at a time)',
  'business.resources.create': 'Create resource',
  'business.resources.publicPageTitle': 'Public booking page and website widget',
  'business.resources.publicPageIntro':
    'Customize the Vennevent-hosted page. Booking, sign-in, capacity checks, and payment always continue securely on Vennevent.',
  'business.resources.accentColour': 'Accent colour',
  'business.resources.defaultLanguage': 'Default language',
  'business.resources.allowedWebsites': 'Websites allowed to embed this widget',
  'business.resources.originPlaceholder': 'https://www.example.com',
  'business.resources.originsHelp': 'Enter exact HTTPS origins, separated by spaces or commas. Paths and wildcards are not supported.',
  'business.resources.publicEnabled': 'Public page enabled',
  'business.resources.showAddress': 'Show address',
  'business.resources.showBranding': 'Show Vennevent branding',
  'business.resources.analytics': 'Coarse, consent-aware referral totals',
  'business.resources.savePage': 'Save booking page',
  'business.resources.embedCode': 'Embed code',
  'business.resources.embedCodeAria': 'Website embed code',
  'business.resources.previewPage': 'Preview public page',
  'business.resources.previewWidget': 'Preview widget',
  'business.resources.kindRoom': 'Room',
  'business.resources.kindCourt': 'Court',
  'business.resources.kindTable': 'Table',
  'business.resources.kindEquipment': 'Equipment',
  'business.resources.kindInstructor': 'Instructor',
  'business.resources.kindOther': 'Other',
  'business.community.settingsSaved': 'Community settings saved.',
  'business.community.settingsError': 'Settings could not be saved.',
  'business.community.postPublished': 'Community post published.',
  'business.community.publishError': 'Post could not be published.',
  'business.community.imageError': 'One of the images could not be processed.',
  'business.community.postUpdated': 'Post updated.',
  'business.community.updateError': 'Post could not be updated.',
  'business.community.deletePostTitle': 'Delete post?',
  'business.community.deletePostBody': 'The post and all of its comments will be permanently deleted.',
  'business.community.postDeleted': 'Post deleted.',
  'business.community.deleteError': 'Post could not be deleted.',
  'business.community.conversationLoadError': 'Conversation could not be loaded.',
  'business.community.replyError': 'Reply could not be sent.',
  'business.community.messageError': 'The message could not be sent.',
  'business.community.conversationUpdateError': 'Conversation could not be updated.',
  'business.community.title': 'Community',
  'business.community.intro': 'Share updates on your public business profile.',
  'business.community.writeUpdate': 'Write an update…',
  'business.community.postAria': 'Community post',
  'business.community.postImages': 'Post images',
  'business.community.publish': 'Publish',
  'business.community.directoryAndChat': 'Directory and chat',
  'business.community.showDirectory': 'Show in community directory',
  'business.community.showDirectoryHelp': 'Let people discover this business.',
  'business.community.allowMessages': 'Allow messages',
  'business.community.allowMessagesHelp': 'Show Message business on the public profile.',
  'business.community.saveSettings': 'Save settings',
  'business.community.publishedPosts': 'Published posts',
  'business.community.loadingPosts': 'Loading posts…',
  'business.community.noPosts': 'No posts published yet.',
  'business.community.publishing': 'Publishing…',
  'business.community.editPost': 'Edit post',
  'business.community.postOptions': 'Post options',
  'business.community.postImageAlt': 'Business post image',
  'business.community.commentCount': 'no comments | one comment | {count} comments',
  'business.community.postPages': 'Published post pages',
  'business.community.sharedInbox': 'Shared inbox',
  'business.community.inboxPrivacy': 'Messages are visible to authorized business staff.',
  'business.community.loadingConversations': 'Loading conversations…',
  'business.community.noMessages': 'No customer messages yet.',
  'business.community.customerId': 'Customer {id}',
  'business.community.updatedAt': 'Updated {date}',
  'business.community.unreadCount': 'no unread messages | one unread message | {count} unread messages',
  'business.community.conversationWith': 'Conversation with {id}',
  'business.community.reopen': 'Reopen',
  'business.community.close': 'Close',
  'business.community.block': 'Block',
  'business.community.retention': 'Conversations expire after 12 months without activity. Both sides receive a warning 30 days before removal.',
  'business.community.removalWarning': 'This inactive conversation is scheduled for removal unless someone replies.',
  'business.community.customer': 'Customer',
  'business.community.yourBusiness': 'Your business',
  'business.community.read': 'Read',
  'business.community.delivered': 'Delivered',
  'business.community.replyPlaceholder': 'Reply as the business',
  'business.community.replyAttachments': 'Reply attachments',
  'business.community.sendReply': 'Send reply',
  'business.community.reportPrompt': 'What should the moderation team know?',
  'business.community.conversationReported': 'Conversation reported for review.',
  'business.community.reportConversationError': 'Conversation could not be reported.',
  'business.community.statusOpen': 'Open',
  'business.community.statusClosed': 'Closed',
  'business.community.statusBlocked': 'Blocked',
  'business.comments.imageError': 'Failed to process image.',
  'business.comments.updated': 'Comment updated.',
  'business.comments.updateError': 'The comment could not be updated.',
  'business.comments.deleteTitle': 'Delete comment?',
  'business.comments.deleteBody': 'This comment will be permanently deleted.',
  'business.comments.deleted': 'Comment deleted.',
  'business.comments.deleteError': 'The comment could not be deleted.',
  'business.comments.signInRequired': 'You must be signed in before posting a comment.',
  'business.comments.publishError': 'The comment could not be published.',
  'business.comments.title': 'Comments',
  'business.comments.loadError': 'Comments could not be loaded.',
  'business.comments.avatarAlt': '{name} avatar',
  'business.comments.imageAlt': 'Comment image',
  'business.comments.edit': 'Edit comment',
  'business.comments.options': 'Comment options',
  'business.comments.empty': 'No comments on this post yet.',
  'business.comments.imageToAdd': 'Image to add',
  'business.comments.removeImage': 'Remove image',
  'business.comments.placeholder': 'Write your comment…',
  'business.comments.send': 'Send comment',
  'business.comments.addImage': 'Add image',
  'business.comments.signIn': 'Sign in with a personal account to comment.',
  'business.finance.periodError': 'The period start must be before its end.',
  'business.finance.exported': 'Accounting export downloaded.',
  'business.finance.exportError': 'Could not export this accounting period.',
  'business.finance.resolutionRequired': 'Add a resolution note before closing the exception.',
  'business.finance.exceptionResolved': 'Reconciliation exception resolved and audited.',
  'business.finance.resolveError': 'Could not resolve the exception.',
  'business.finance.accessGranted': 'Finance access granted. The user must already be accepted business staff.',
  'business.finance.grantError': 'Could not grant finance access.',
  'business.finance.refundTitle': 'Refund {title}',
  'business.finance.denyTitle': 'Deny refund request',
  'business.finance.refundAmountHelp': 'Enter the refund amount in {currency}. Maximum: {maximum}.',
  'business.finance.decisionNote': 'Decision note',
  'business.finance.denyRequest': 'Deny request',
  'business.finance.auditReason': 'Financial audit reason',
  'business.finance.approvalReason': 'Reason for approving this refund',
  'business.finance.cancelAttendanceTitle': 'Also cancel attendance?',
  'business.finance.cancelAttendanceBody': 'Refunding and cancelling attendance are separate. Attendance changes only after Vipps confirms the refund.',
  'business.finance.refundAndCancel': 'Refund and cancel',
  'business.finance.refundOnly': 'Refund only',
  'business.finance.refundSubmitted': 'Refund submitted to Vipps.',
  'business.finance.refundDenied': 'Refund request denied.',
  'business.finance.reviewError': 'Could not review the refund request.',
  'business.finance.title': 'Finance and reconciliation',
  'business.finance.intro':
    'Reproducible UTC accounting periods from provider-authoritative payment records. Customer names and payment credentials are never included.',
  'business.finance.loading': 'Loading finance workspace',
  'business.finance.accessRequired': 'Finance data requires a separate finance grant. Ordinary business staff access is not sufficient.',
  'business.finance.accountingPeriod': 'Accounting period',
  'business.finance.fromUtc': 'From (UTC)',
  'business.finance.throughUtc': 'Through (UTC)',
  'business.finance.applyPeriod': 'Apply period',
  'business.finance.exportCsv': 'Export CSV',
  'business.finance.charges': 'Charges',
  'business.finance.refundsFees': 'Refunds and fees',
  'business.finance.settlements': 'Settlement entries',
  'business.finance.ledgerNet': 'Ledger net',
  'business.finance.noActivity': 'No ledger activity exists in this period.',
  'business.finance.exceptions': 'Reconciliation exceptions',
  'business.finance.reference': 'Reference',
  'business.finance.notSupplied': 'not supplied',
  'business.finance.expected': 'expected',
  'business.finance.ledger': 'ledger',
  'business.finance.detected': 'Detected {date}',
  'business.finance.resolutionNote': 'Resolution note',
  'business.finance.resolutionPlaceholder': 'Explain how the variance was verified',
  'business.finance.resolve': 'Resolve',
  'business.finance.review': 'Review',
  'business.finance.refundRequests': 'Attendee refund requests',
  'business.finance.approveRefund': 'Approve refund',
  'business.finance.deny': 'Deny',
  'business.finance.ledgerEntries': 'Ledger entries',
  'business.finance.timeUtc': 'Time (UTC)',
  'business.finance.source': 'Source',
  'business.finance.amount': 'Amount',
  'business.finance.grantTitle': 'Grant separate finance access',
  'business.finance.grantHelp': 'The user must already be accepted business staff. Business roles never grant finance access implicitly.',
  'business.finance.staffUserId': 'Accepted staff user ID',
  'business.finance.role': 'Finance role',
  'business.finance.roleViewer': 'View',
  'business.finance.roleExporter': 'View and export',
  'business.finance.roleAdministrator': 'Finance administrator',
  'business.finance.grantAccess': 'Grant access',
  'business.finance.entryCharge': 'Charge',
  'business.finance.entryRefund': 'Refund',
  'business.finance.entryFee': 'Fee',
  'business.finance.entrySettlement': 'Settlement',
  'business.finance.entryCorrection': 'Correction',
  'business.finance.sourceEvent': 'Event',
  'business.finance.sourceResource': 'Resource',
  'business.finance.sourceSubscription': 'Subscription',
  'business.finance.sourceProvider': 'Provider',
  'business.operations.unknownResource': 'Unknown resource',
  'business.operations.acceptedStaff': 'Accepted staff member',
  'business.operations.refreshed': 'Operations refreshed. Review your retained values before submitting again.',
  'business.operations.invalidInstants': 'Enter both times as exact ISO instants with Z or a numeric UTC offset.',
  'business.operations.endAfterStart': 'The end instant must be after the start instant.',
  'business.operations.updateError': 'Could not update operations.',
  'business.operations.rescheduled': 'Booking rescheduled. The customer notification is queued after the committed change.',
  'business.operations.rescheduleError': 'Could not reschedule this booking.',
  'business.operations.maintenanceCreated': 'Maintenance block created and audited.',
  'business.operations.maintenanceUpdated': 'Maintenance block updated and audited.',
  'business.operations.maintenanceSaveError': 'Could not save this maintenance block.',
  'business.operations.maintenanceCancelled': 'Maintenance block cancelled. Its audit history is retained.',
  'business.operations.maintenanceCancelError': 'Could not cancel this maintenance block.',
  'business.operations.assignmentAdded': 'Staff assignment added and audited.',
  'business.operations.assignmentAddError': 'Could not add this assignment.',
  'business.operations.assignmentRemoved': 'Staff assignment removed and audited.',
  'business.operations.assignmentRemoveError': 'Could not remove this assignment.',
  'business.operations.noteSaved': 'Private operational note saved and audited.',
  'business.operations.noteSaveError': 'Could not save this operational note.',
  'business.operations.title': 'Resource operations',
  'business.operations.intro':
    'Bookings, preparation buffers, maintenance, capacity, and staff in each resource’s timezone. All changes use forms—dragging is never required.',
  'business.operations.refresh': 'Refresh operations',
  'business.operations.loading': 'Loading resource operations',
  'business.operations.unavailable': 'Resource operations are unavailable or your staff role does not permit access.',
  'business.operations.day': 'Day',
  'business.operations.week': 'Week',
  'business.operations.previousView': 'Previous {view}',
  'business.operations.nextView': 'Next {view}',
  'business.operations.calendarDate': 'Calendar date',
  'business.operations.addMaintenance': 'Add maintenance',
  'business.operations.timezoneHelp':
    'Dates are calendar dates applied separately in each listed IANA timezone. Times include their UTC offset, including across DST changes.',
  'business.operations.scheduleChanged': 'Schedule changed since you opened it',
  'business.operations.scheduleConflict': 'Schedule conflict',
  'business.operations.conflictPrivacy': 'No customer details are exposed. Your entered values have been retained.',
  'business.operations.conflictRefreshed': 'The current schedule is loaded. Review the conflict and submit again only if the interval is still appropriate.',
  'business.operations.createResourceFirst': 'Create a bookable resource before using the operations calendar.',
  'business.operations.calendarAria': '{view} resource operations calendar',
  'business.operations.resource': 'Resource',
  'business.operations.capacity': 'Capacity {capacity}',
  'business.operations.exclusive': 'exclusive',
  'business.operations.buffers': 'Buffers {before}m before / {after}m after',
  'business.operations.cellAria': '{resource}, {date}, {count} operations',
  'business.operations.openDetailsAria': '{title}, {interval}, open details',
  'business.operations.quantity': 'Quantity {quantity} / {capacity}',
  'business.operations.assignedCount': 'none assigned | one assigned | {count} assigned',
  'business.operations.addMaintenanceAria': 'Add maintenance for {resource}; exact instant form opens blank',
  'business.operations.maintenance': 'Maintenance',
  'business.operations.noOperations': 'No operations',
  'business.operations.agenda': 'Chronological agenda',
  'business.operations.emptyPeriod': 'No booking, buffer, or maintenance operations occur in this period.',
  'business.operations.newMaintenance': 'New maintenance block',
  'business.operations.isoHelpBefore': 'Exact ISO instants include',
  'business.operations.isoHelpAfter': 'or an explicit UTC offset. This avoids ambiguous or nonexistent DST wall times.',
  'business.operations.closeEditor': 'Close operations editor',
  'business.operations.bufferHelp': 'This protected buffer follows its booking. Reschedule the booking to move it.',
  'business.operations.rescheduleAria': 'Reschedule booking without dragging',
  'business.operations.rescheduleBooking': 'Reschedule booking',
  'business.operations.startInstant': 'Start · Exact ISO instant',
  'business.operations.endInstant': 'End · Exact ISO instant',
  'business.operations.rescheduleHelp':
    'Resource, duration, quantity, trusted price, payment state, and customer are preserved. Change those through cancellation/refund and a new booking.',
  'business.operations.checkAndReschedule': 'Check availability and reschedule',
  'business.operations.createMaintenanceAria': 'Create maintenance without dragging',
  'business.operations.editMaintenanceAria': 'Edit maintenance without dragging',
  'business.operations.createMaintenance': 'Create maintenance / blackout',
  'business.operations.editMaintenance': 'Edit maintenance / blackout',
  'business.operations.publicSummary': 'Public summary',
  'business.operations.privateNoteOptional': 'Private operational note (optional)',
  'business.operations.privateNoteHelp': 'Authorized operations staff only; never shown to customers or embeds.',
  'business.operations.checkAndCreate': 'Check conflicts and create',
  'business.operations.checkAndSave': 'Check conflicts and save',
  'business.operations.cancelMaintenance': 'Cancel maintenance',
  'business.operations.staffAssignments': 'Staff assignments',
  'business.operations.removeAssignmentAria': 'Remove {name} assignment',
  'business.operations.noStaff': 'No staff assigned.',
  'business.operations.assignStaffAria': 'Assign staff without dragging',
  'business.operations.roleLabel': 'Operational role label',
  'business.operations.rolePlaceholder': 'Opening lead',
  'business.operations.assign': 'Assign',
  'business.operations.editPrivateNoteAria': 'Edit private operational note',
  'business.operations.privateNote': 'Private operational note',
  'business.operations.privateNoteVisibility': 'Visible only to authorized operations staff and excluded from customer notifications, exports, and embeds.',
  'business.operations.savePrivateNote': 'Save private note',
  'business.profile.metadataDescription': 'Learn about {name} on Vennevent.',
  'business.profile.photoAlt': '{name} photo {number}',
  'business.profile.shareText': 'Discover {name} on Vennevent',
  'business.profile.shared': 'Business shared.',
  'business.profile.linkCopied': 'Business link copied to your clipboard.',
  'business.profile.shareError': 'Unable to share this business. Please try again.',
  'business.profile.loading': 'Loading business profile',
  'business.profile.unavailable': 'This business profile is unavailable.',
  'business.profile.logoAlt': '{name} logo',
  'business.profile.addressMissing': 'Address not provided',
  'business.profile.approximately': 'Approximately {distance}',
  'business.profile.editBusiness': 'Edit business',
  'business.profile.actions': 'Business actions',
  'business.profile.book': 'Book',
  'business.profile.message': 'Message',
  'business.profile.upcomingEventCount': 'no upcoming events | one upcoming event | {count} upcoming events',
  'business.profile.call': 'Call',
  'business.profile.share': 'Share',
  'business.profile.sections': 'Business profile sections',
  'business.profile.about': 'About',
  'business.profile.posts': 'Posts',
  'business.profile.events': 'Events',
  'business.profile.booking': 'Booking',
  'business.profile.chat': 'Chat',
  'business.profile.postCount': 'no posts | one post | {count} posts',
  'business.profile.bookingAvailable': 'Booking available',
  'business.profile.chatAvailable': 'Chat available',
  'business.profile.introductionMissing': 'This business has not added an introduction yet.',
  'business.profile.contact': 'Contact',
  'business.profile.contactMissing': 'Contact details have not been provided.',
  'business.profile.hoursMissing': 'Opening hours have not been provided.',
  'business.profile.exceptionalHours': 'Exceptional hours',
  'business.profile.accessibilityMissing': 'Accessibility information has not been provided.',
  'business.profile.photos': 'Photos',
  'business.profile.noPhotos': 'No additional photos have been added.',
  'business.profile.openPhotoAria': 'Open {alt} full screen',
  'business.profile.mapMissing': 'A map location has not been provided.',
  'business.profile.postAs': 'Post as {name}',
  'business.profile.shareUpdate': 'Share an update on this business profile.',
  'business.profile.businessPost': 'Business post',
  'business.profile.addPhotos': 'Add photos',
  'business.profile.postsLoadError': 'Posts could not be loaded.',
  'business.profile.postImageAlt': '{name} post image',
  'business.profile.postPages': 'Business post pages',
  'business.profile.eventPeriod': 'Event period',
  'business.profile.upcoming': 'Upcoming',
  'business.profile.pastEvents': 'Past events',
  'business.profile.eventsLoadError': 'Events could not be loaded.',
  'business.profile.noUpcomingEvents': 'No upcoming events.',
  'business.profile.noPastEvents': 'No past events.',
  'business.profile.recurring': 'Recurring',
  'business.profile.bookingLoadError': 'Booking could not be loaded.',
  'business.profile.signInToMessage': 'Sign in with a personal account to message this business.',
  'business.profile.businessChatRestriction': 'Business identities cannot start customer chats. Switch to a personal account to continue.',
  'business.profile.conversationLoadError': 'Conversation could not be loaded.',
  'business.profile.chatRetention': 'Messages expire after 12 months without activity. We will warn you 30 days before removal.',
  'business.profile.you': 'You',
  'business.profile.messagePlaceholder': 'How can they help?',
  'business.profile.attachmentHelp': 'Up to 5 images or PDFs, 10 MB each.',
  'business.profile.sendMessage': 'Send message',
} as const;
